var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { PulseBetButton } from "../../../../components/PulseBetButton";
var baseClass = "rj-pulse-bet-market__accepted-bet";
var AcceptedBet = /** @class */ (function (_super) {
    __extends(AcceptedBet, _super);
    function AcceptedBet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //currently for the handler it is unclear what it should do from bussiness side so for now we removing onClick
    AcceptedBet.prototype.render = function () {
        return (React.createElement("div", { className: baseClass + "-container", onClick: this.props.data.areaHandler },
            React.createElement("div", { className: baseClass + "-message" }, this.props.data.message),
            React.createElement("div", { className: baseClass + "-ticket-container" },
                React.createElement("span", { className: baseClass + "-interval" }, this.props.data.timeInterval),
                React.createElement("span", { className: baseClass + "-ticket" }, this.props.data.ticketLabel),
                React.createElement("span", { className: baseClass + "-number" }, this.props.data.ticketId)),
            React.createElement(PulseBetButton, { modifier: "accepted-bet", handler: this.props.data.handler }, this.props.data.buttonLabel)));
    };
    return AcceptedBet;
}(React.Component));
export { AcceptedBet };
//# sourceMappingURL=AcceptedBet.js.map